import * as queryString from "query-string";

import { Element, scroller } from "react-scroll";
import Layout, { Wrapper } from "components/general/Layout";
import React, { Component } from "react";
import { createApplication, createShortApplication } from "slices/candidates";

import Checkbox from "components/general/Checkbox";
import ColumnLink from "components/jobs/ColumnLink";
import CompanyLogo from "components/general/CompanyLogo";
import ContentPageLinks from "components/jobs/JobPageContentPageLinks";
import EnvironmentIndicator from "components/dev/EnvironmentIndicator";
// import Header from "components/jobs/Header";
import { Helmet } from "react-helmet";
import Input from "components/general/Input";
// import JobClipPersistentPlayer from "components/jobs/JobClipPersistentPlayer";
import { JobPageApplication } from "components/jobs/JobPageApplication";
import Label from "components/general/Label";
import MadeWithPuckBadge from "components/general/MadeWithPuckBadge";
// import LongForm from "components/long_form/LongForm";
import PillButton from "components/general/PillButton";
// import JobPageJobClipPlaylist from "components/jobs/JobPageJobClipPlaylist";
import PlayerInternal from "components/player_internal/PlayerInternal";
import Select from "components/general/Select";
import TeamQuote from "components/jobs/TeamQuote";
import { TimeSpent } from "utils/timeSpent";
// import WebFont from "webfontloader";
import { analytics } from "utils/analytics";
import { bindActionCreators } from "redux";
import { compose } from "redux";
import { connect } from "react-redux";
import debounce from "lodash/debounce";
import { decodeHTML } from "entities";
import { getAllAnonymousIds } from "utils/analytics";
import { hexToCSSFilter } from "hex-to-css-filter";
import iconHeadphone from "images/ic_headphone_black.png";
import imageBadge from "images/img_badge.png";
// import imagePuckBadge from "images/puck-logo.png";
import ipLookup from "utils/ipLookup";
import isEmail from "validator/lib/isEmail";
import { lngLookup } from "utils/i18n";
import { loadPublicJobPage } from "slices/jobs";
import styled from "styled-components";
import theme from "styles/theme";
import { unwrapResult } from "@reduxjs/toolkit";
import withRouter from "hocs/withRouter";
import { withTranslation } from "react-i18next";
import xss from "xss";

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  max-width: 640px;
`;

const PageHeaderContainer = styled.div`
  padding: ${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 4}px;

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  row-gap: ${theme.spacing.unit * 2}px;
`;

const Role = styled.div`
  font-size: 40px;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

const Location = styled.div`
  font-size: 20px;
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;

const SmallBottomContentContainer = styled.div`
  display: none;
  margin: ${theme.spacing.unit * 4}px 0;

  flex-direction: column;
  row-gap: ${theme.spacing.unit * 4}px;

  ${theme.media.mini`
    display: flex;
    margin: ${theme.spacing.unit * 3}px 0;
    row-gap: ${theme.spacing.unit * 3}px;
  `}
`;

const FooterLinksContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: ${theme.spacing.unit * 2}px;
  margin: 40px 0;
`;

const FooterLink = styled.a`
  text-align: center;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 112%;
  color: ${theme.colors.gray3};
`;

const About = styled.div`
  font-size: 16px; !important;
  font-family: Inter; !important;
  font-style: normal; !important;
  font-weight: 400; !important;
  line-height: 140%; !important;
  color: ${(props) => props.color} !important;

  h1,
  .h1-lever {
    font-weight: 500 !important;
    font-size: 28px !important;
    line-height: 120%; !important;
  }

  h2,
  .h2-lever {
    font-weight: 500 !important;
    font-size: 24px !important;
    line-height: 120%; !important;
  }

  h3,
  .h3-lever {
    font-size: 20px !important;
    line-height: 120%; !important;
  }

  a {
    // font-weight: 600 !important;
    text-decoration-line: underline !important;
  }

  b {
    font-weight: 600 !important;
  }

  i {
    font-style: italic !important;
  }

  ul {
    padding-inline-start: 22px !important;
  }

  // li {
  //   list-style-type: none !important;
  //   position: relative !important; /* It's needed for setting position to absolute in the next rule. */
  // }

  // li::before {
  //   content: "■" !important;
  //   position: absolute !important;
  //   left: -16px !important; /* Adjust this value so that it appears where you want. */
  //   font-size: 4px !important; /* Adjust this value so that it appears what size you want. */
  // }

  li:not(:last-child) {
    margin-bottom: ${theme.spacing.unit * 1}px !important;
  }

  img {
    max-width: 100%;
    height: auto;
  }
`;

const ShortFormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ShortFormTitle = styled.div`
  margin: 48px 0 12px;

  font-size: 24px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
`;

const ShortFormEmailInput = styled(Input)``;

const BottomApplyButton = styled(PillButton)`
  align-self: flex-end;
  margin-top: 12px;
`;

const ThirdPartyApplyContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const ColumnsContainer = styled.div`
  display: flex;
  justify-content: center;
  column-gap: ${theme.spacing.unit * 2}px;
  max-width: 1064px;
  margin: 0 auto;

  ${theme.media.mini`
    flex-direction: column;
    align-items: center;
  `}
`;

// const LeftColumn = styled.div`
//   width: 404px;
//   min-width: 288px;
//   display: flex;
//   flex-shrink: 1;
//   padding: 0 ${theme.spacing.unit * 2}px;
//   box-sizing: border-box;
//   // height: 64px;

//   ${theme.media.small`
//     width: 640px;
//     justify-content: center;
//     align-items: center;
//     flex-shrink: 0;
//     position: relative;
//   `}

//   ${theme.media.phone`
//     margin-top: ${theme.spacing.unit * 5}px;
//     max-width: 100%;
//     min-width: 0;
//     width: 100%;
//     justify-content: center;
//     align-items: center;
//     flex-shrink: 1;
//     position: relative;
//   `}
// `;

const LogoContainer = styled.div`
  margin-top: 64px;
  position: relative;
  display: flex;
  justify-content: center;

  ${theme.media.mini`
    margin-top: 40px;
  `}
`;

// const LogoStickyContainer = styled.div`
//   position: sticky;
//   top: ${theme.spacing.unit * 2}px;
// `;

const MiddleColumn = styled.div`
  ${(props) =>
    !props.$hidePuckBranding && `padding-top: ${theme.spacing.unit * 2}px;`}

  width: 640px;
  flex-shrink: 1;

  ${theme.media.mini`
    width: 100%;
    flex-shrink: 1;
  `}
`;

const RightColumn = styled.div`
  flex: 0 1 408px;
  min-width: 348px;

  box-sizing: border-box;
`;

const RightColumnContentContainer = styled.div`
  position: sticky;
  top: 0;
`;

const BadgeContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-bottom: -${theme.spacing.unit * 2}px;
`;

const MobileBadgeContainer = styled(BadgeContainer)`
  margin-bottom: -${theme.spacing.unit * 1}px;
`;

const Badge = styled.img`
  height: 15px;
  align-self: flex-end;

  ${(props) =>
    `filter: brightness(0) saturate(100%) ${
      hexToCSSFilter(props.color).filter
    };`};
`;

const RightColumnSpacer = styled.div`
  visibility: hidden;
  display: none;
`;

const RightColumnContent = styled.div`
  align-self: flex-end;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: ${theme.spacing.unit * 2}px 0 ${theme.spacing.unit * 4}px;
  row-gap: ${theme.spacing.unit * 4}px;
`;

const MadeWithPuckContainer = styled.div`
  display: flex;

  margin-top: 72px;
  justify-content: center;
  align-items: center;

  ${theme.media.mini`
    display: flex;
    margin-left: -40px;
    padding: 8.68px 22.51px;
  `}
`;

const ScreeningQuestionSelect = styled(Select)`
  padding-top: ${theme.spacing.unit * 1}px;
`;

const ScreeningQuestionCheckboxContainer = styled.div`
  padding: ${theme.spacing.unit * 1}px;
`;

const ScreeningQuestionMultiSelectError = styled.div`
  margin-top: ${theme.spacing.unit * 1}px;

  // Text
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: ${theme.colors.red};
`;

const MobileTeamQuoteContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export class JobPagePublic extends Component {
  teamQuoteViewTimer = null;

  constructor(props) {
    super(props);

    this.handleScrollAnalytics = debounce(
      this.handleScrollAnalytics.bind(this),
      750
    );

    this.playerRefs = [];
    this.mobilePlayerRefs = [];

    this.jobDescriptionRef = React.createRef();
    this.isReadingJobDescription = false;

    this.rightColumn = React.createRef();
    this.rightColumnContentContainer = React.createRef();
    this.rightColumnSpacer = React.createRef();
    this.rightColumnContent = React.createRef();

    this.state = {
      jobPage: null,
      isPermalinkValid: true,

      maxScrollPixels: 0,
      maxScrollPercentage: 0,

      locationHash: null,

      isMini: false,
      isMobile: false,

      email: "",
      isEmailTouched: false,

      screeningQuestionResponses: [],
      screeningQuestionErrors: null,

      isSubmittingShortForm: false,

      jobClips: null,
      jobClipHighlight: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    window.addEventListener("scroll", this.handleScroll);

    this.checkIsMini();
    this.checkIsMobile();
    analytics.page();

    if (window.location.hash) {
      this.setState({
        locationHash: window.location.hash,
      });
    }

    this.initJobPage();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);

    if (this.timeOnPage) {
      this.timeOnPage.stop();
    }
    if (this.timeReadingJobDescription) {
      this.timeReadingJobDescription.stop();
    }
    if (this.teamQuoteViewTimer) {
      clearTimeout(this.teamQuoteViewTimer);
    }
  }

  checkIsMobile = () => {
    const isPhoneMediaQuery = theme.media.phoneQuery;
    this.setState({
      isMobile: isPhoneMediaQuery.matches,
    });
    isPhoneMediaQuery.onchange = this.handleIsPhoneMediaQueryChange;
  };

  handleIsPhoneMediaQueryChange = (isPhoneMediaQuery) => {
    this.setState({
      isMobile: isPhoneMediaQuery.matches,
    });
  };

  handleIsMiniMediaQueryChange = (isMiniMediaQuery) => {
    this.setState({
      isMini: isMiniMediaQuery.matches,
    });
  };

  checkIsMini = () => {
    const isMiniMediaQuery = theme.media.miniQuery;
    this.setState({
      isMini: isMiniMediaQuery.matches,
    });
    isMiniMediaQuery.onchange = this.handleIsMiniMediaQueryChange;
  };

  handleRightColumnScroll = () => {
    if (!this.rightColumn.current) {
      return;
    }

    const rightColumnRect = this.rightColumn.current.getBoundingClientRect();
    const rightColumnContentRect =
      this.rightColumnContent.current.getBoundingClientRect();

    if (
      window.innerHeight >
      this.rightColumnContent.current.getBoundingClientRect().height
    ) {
      // We can fit the whole right column on the screen
      this.rightColumnContentContainer.current.position = "sticky";
      this.rightColumnContentContainer.current.style.top = 0;

      this.rightColumnContent.current.style.position = "relative";
      this.rightColumnContent.current.style.bottom = "unset";

      this.rightColumnSpacer.current.style.height = 0;
      this.rightColumnSpacer.current.style.display = "none";

      return;
    } else {
      this.rightColumnContentContainer.current.position = "relative";
      this.rightColumnContentContainer.current.style.top = "unset";

      this.rightColumnContent.current.style.position = "sticky";
      this.rightColumnContent.current.style.bottom = 0;

      this.rightColumnSpacer.current.style.height = `${
        rightColumnRect.height - rightColumnContentRect.height
      }px`;
      this.rightColumnSpacer.current.style.display = "block";
    }
  };

  handleScroll = (e) => {
    this.handleRightColumnScroll();

    const target = e.target;
    this.handleScrollAnalytics(target);

    if (!this.timeReadingJobDescription) {
      return;
    }

    if (this.jobDescriptionRef.current) {
      const rect = this.jobDescriptionRef.current.getBoundingClientRect();
      const topAboveMidpoint = rect.top < window.innerHeight / 2;
      const bottomAboveMidpoint = rect.bottom < window.innerHeight / 2;
      if (topAboveMidpoint && !bottomAboveMidpoint) {
        if (!this.isReadingJobDescription) {
          this.timeReadingJobDescription.start();
          dispatchEvent(
            new CustomEvent("adminEvent", {
              detail: "Started reading job description",
            })
          );
        }
        this.isReadingJobDescription = true;
      } else if (this.isReadingJobDescription) {
        this.timeReadingJobDescription.stop();
        dispatchEvent(
          new CustomEvent("adminEvent", {
            detail: "Stopped reading job description",
          })
        );
        this.isReadingJobDescription = false;
      }
    }
  };

  handleScrollAnalytics = (target) => {
    const { jobPage, maxScrollPercentage } = this.state;
    const { location } = this.props;

    const queryParams = queryString.parse(location.search);

    const pctScrolled = Math.floor(
      (100 * window.scrollY) /
        (document.documentElement.scrollHeight - window.innerHeight)
    );

    if (pctScrolled > maxScrollPercentage) {
      const maxScrollPixels = window.scrollY;
      const newMaxScrollPercentage = pctScrolled;

      this.setState({
        maxScrollPixels,
        newMaxScrollPercentage,
      });

      dispatchEvent(
        new CustomEvent("adminEvent", {
          detail: `Max scroll: ${maxScrollPixels} - ${newMaxScrollPercentage}`,
        })
      );

      if (this.state.jobPage?.employerProfile?.isLiveWithJobPages) {
        analytics.track("JobPage Public Scrolled", {
          jobPage,
          queryParams,
          maxScrollPixels,
          newMaxScrollPercentage,
        });
      }
    }
  };

  handleClick = (ev) => {
    const { jobPage } = this.state;
    const { location } = this.props;

    const queryParams = queryString.parse(location.search);

    dispatchEvent(
      new CustomEvent("adminEvent", {
        detail: `Click observed`,
      })
    );

    if (this.state.jobPage.employerProfile.isLiveWithJobPages) {
      analytics.track("JobPage Public Generic Click", {
        jobPage,
        queryParams,
      });
    }
  };

  loadCustomFonts = () => {
    const { jobPage } = this.state;

    const brandingData = jobPage.employerProfile.brandingData;

    const roleFontUrl = brandingData.roleFontUrl;
    if (roleFontUrl) {
      const roleFont = new FontFace("Role Custom Font", `url(${roleFontUrl})`);
      roleFont
        .load()
        .then(function (loadedFont) {
          document.fonts.add(loadedFont);
        })
        .catch(function (error) {
          console.log("Failed to load font: " + error);
        });
    }

    const employerNameFontUrl = brandingData.employerNameFontUrl;
    if (employerNameFontUrl) {
      const employerNameFont = new FontFace(
        "Employer Name Custom Font",
        `url(${employerNameFontUrl})`
      );
      employerNameFont
        .load()
        .then(function (loadedFont) {
          document.fonts.add(loadedFont);
        })
        .catch(function (error) {
          console.log("Failed to load font: " + error);
        });
    }

    const jobDescriptionRegularFontUrl =
      brandingData.jobDescriptionRegularFontUrl;
    if (jobDescriptionRegularFontUrl) {
      const jobDescriptionRegularFont = new FontFace(
        "Job Description Custom Font",
        `url(${jobDescriptionRegularFontUrl})`,
        {
          style: "normal",
          weight: "400",
        }
      );
      jobDescriptionRegularFont
        .load()
        .then(function (loadedFont) {
          document.fonts.add(loadedFont);
        })
        .catch(function (error) {
          console.log("Failed to load font: " + error);
        });
    }

    const jobDescriptionItalicFontUrl =
      brandingData.jobDescriptionItalicFontUrl;
    if (jobDescriptionItalicFontUrl) {
      const jobDescriptionItalicFont = new FontFace(
        "Job Description Custom Font",
        `url(${jobDescriptionItalicFontUrl})`,
        {
          style: "italic",
          weight: "400",
        }
      );
      jobDescriptionItalicFont
        .load()
        .then(function (loadedFont) {
          document.fonts.add(loadedFont);
        })
        .catch(function (error) {
          console.log("Failed to load font: " + error);
        });
    }

    const jobDescriptionBoldFontUrl = brandingData.jobDescriptionBoldFontUrl;
    if (jobDescriptionBoldFontUrl) {
      const jobDescriptionBoldFont = new FontFace(
        "Job Description Custom Font",
        `url(${jobDescriptionBoldFontUrl})`,
        {
          style: "normal",
          weight: "700",
        }
      );
      jobDescriptionBoldFont
        .load()
        .then(function (loadedFont) {
          document.fonts.add(loadedFont);
        })
        .catch(function (error) {
          console.log("Failed to load font: " + error);
        });
    }

    const jobDescriptionBoldItalicFontUrl =
      brandingData.jobDescriptionBoldItalicFontUrl;
    if (jobDescriptionBoldItalicFontUrl) {
      const jobDescriptionBoldItalicFont = new FontFace(
        "Job Description Custom Font",
        `url(${jobDescriptionBoldItalicFontUrl})`,
        {
          style: "italic",
          weight: "700",
        }
      );
      jobDescriptionBoldItalicFont
        .load()
        .then(function (loadedFont) {
          document.fonts.add(loadedFont);
        })
        .catch(function (error) {
          console.log("Failed to load font: " + error);
        });
    }
  };

  trackTeamQuoteViewed = () => {
    const { jobPage, jobClipHighlight } = this.state;

    if (jobClipHighlight) {
      analytics.track("JobPage Team Quote Viewed", {
        jobPage,
        jobClipHighlightPermalink: jobClipHighlight.permalink,
      });
    }
  };

  initJobPage = async () => {
    const { dispatch, location, params, i18n } = this.props;
    const { jobBoardPermalink, jobPagePermalink } = params;

    const queryParams = queryString.parse(location.search);

    const resultAction = await dispatch(
      loadPublicJobPage({
        jobBoardPermalink: jobBoardPermalink,
        jobPagePermalink: jobPagePermalink,
      })
    );
    if (loadPublicJobPage.fulfilled.match(resultAction)) {
      // Count the team quote as viewed after 5s
      this.teamQuoteViewTimer = setTimeout(this.trackTeamQuoteViewed, 5000);

      const jobPage = unwrapResult(resultAction);

      // Randomize the job clip order
      const jobClips = jobPage.jobClips
        .map((jc) => ({ jobClip: jc.jobClip, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map((value) => value.jobClip)
        .slice(0, 4);

      if (jobPage.jobClipHighlights?.length > 0) {
        // Filter down to highlights with non-host speakers first
        // Then randomize the order
        const jobClipHighlights = jobPage.jobClipHighlights
          .filter((jch) => {
            return jch.speakers.some((speaker) => !speaker.isHost);
          })
          .map((jch) => ({ jobClipHighlight: jch, sort: Math.random() }))
          .sort((a, b) => a.sort - b.sort)
          .map((value) => value.jobClipHighlight);

        if (jobClipHighlights.length > 0) {
          // Default to the first highlight
          let jobClipHighlight = null;

          // If there are job clips, try to find a highlight with a different speaker
          if (jobClips.length > 0) {
            // const firstJobClipFirstNonHostSpeaker = jobClips[0].speakers.find(
            //   (speaker) => !speaker.isHost
            // );
            const lastJobClipFirstNonHostSpeaker = jobClips[
              jobClips.length - 1
            ].speakers.find((speaker) => !speaker.isHost);
            jobClipHighlight = jobClipHighlights.find((jch) => {
              const firstNonHostSpeaker = jch.speakers.find(
                (speaker) => !speaker.isHost
              );
              return (
                firstNonHostSpeaker &&
                lastJobClipFirstNonHostSpeaker &&
                firstNonHostSpeaker.userPermalink !==
                  lastJobClipFirstNonHostSpeaker.userPermalink
              );
            });
          } else {
            jobClipHighlight = jobClipHighlights[0];
          }

          if (jobClipHighlight) {
            this.setState({
              jobClipHighlight,
            });
          }
        }
      }

      // match language-codes from the end of permalinks
      if (jobPagePermalink.match(/-(\w{2}|\w{2}-\w{2})$/)) {
        const codes = jobPagePermalink.match(/-(\w{2}|\w{2}-\w{2})$/);
        queryParams.lng = codes[1];
        // console.log(
        //   "Found language code from permalink:",
        //   jobPagePermalink,
        //   codes[1]
        // );
        i18n.changeLanguage(codes[1]);
      }
      if (!queryParams.lng) {
        i18n.changeLanguage(lngLookup(jobPage.language));
        // console.log("Changing language to:", lngLookup(jobPage.language));
      }

      // Create refs for each player
      jobClips.forEach((jc) => {
        this.playerRefs[jc.permalink] = React.createRef();
        this.mobilePlayerRefs[jc.permalink] = React.createRef();
      });

      // Set both so the page is rendered by the time the callback returns!
      this.setState(
        {
          jobPage,
          jobClips,
        },
        () => {
          this.loadCustomFonts();

          if (this.state.jobPage.employerProfile.isLiveWithJobPages) {
            analytics.identify(
              undefined,
              {
                sourceJobPage: jobPage.permalink,
                sourceJobPageEmployer: jobPage.employerProfile.name,
              },
              {},
              () => {
                analytics.track("Visited JobPage Public", {
                  jobPage,
                  queryParams,
                  i18n,
                  numJobClips: jobClips.length,
                });

                for (const [i, jobClip] of this.state.jobClips.entries()) {
                  analytics.track("JobClip Displayed", {
                    jobClip,
                    jobPage,
                    queryParams,
                    i18n,
                    permalink: jobClip.permalink,
                    jobPagePermalink: this.state.jobPage.permalink,
                    position: i,
                  });
                }

                this.timeOnPage = new TimeSpent((data) => {
                  analytics.track("JobPage Time Spent", {
                    jobPage,
                    queryParams,
                    i18n,
                    duration: data.intervalSec,
                    totalDuration: data.totalElapsedSec,
                  });
                });
                this.timeOnPage.start();

                this.timeReadingJobDescription = new TimeSpent((data) => {
                  analytics.track(
                    "JobPage Reading Job Description Time Spent",
                    {
                      jobPage,
                      queryParams,
                      i18n,
                      duration: data.intervalSec,
                      totalDuration: data.totalElapsedSec,
                      isPlayingJobClip:
                        !!this.state.playingJobClip && !this.state.shouldPause,
                    }
                  );
                });
              }
            );
          }

          this.handleHash();
        }
      );
    } else {
      this.setState({
        isPermalinkValid: false,
      });
    }
  };

  handleHash = () => {
    const { locationHash } = this.state;

    if (locationHash === "#apply") {
      scroller.scrollTo("application", {
        delay: 400,
        duration: 400,
        smooth: true,
        offset: -56,
        // containerId: "scrollingContainer",
      });
    }
  };

  handleApplyClick = () => {
    const { jobPage } = this.state;
    const { location } = this.props;

    const queryParams = queryString.parse(location.search);

    if (this.state.jobPage.employerProfile.isLiveWithJobPages) {
      analytics.track("JobPage Public Clicked Apply", {
        jobPage,
        queryParams,
      });
    }

    scroller.scrollTo("application", {
      duration: 400,
      smooth: true,
      offset: -56,
      // containerId: "scrollingContainer",
    });
  };

  handleThirdPartyApplyClick = async () => {
    const { jobPage } = this.state;
    const { location, params } = this.props;
    const { jobBoardPermalink, jobPagePermalink } = params;

    const queryParams = queryString.parse(location.search);

    if (this.state.jobPage.employerProfile.isLiveWithJobPages) {
      analytics.track("JobPage Public Clicked Apply", {
        jobPage,
        queryParams,
      });
    }

    if (jobPage.applyUrl) {
      window.location.href = jobPage.applyUrl;
    } else {
      this.props.navigate(
        `/job-board/${jobBoardPermalink}/job/${jobPagePermalink}/apply${location.search}`
      );
    }
  };

  handleHearClipsFromTheTeamClick = () => {
    scroller.scrollTo("small-bottom-content", {
      duration: 400,
      smooth: true,
      offset: -56,
      // containerId: "scrollingContainer",
    });
  };

  getReferrerDomain = () => {
    let referrerUrl = null;
    try {
      referrerUrl = new URL(document.referrer);
    } catch {}
    return referrerUrl && referrerUrl.hostname;
  };

  jobClipAnalyticsPayload = (playingJobClip) => {
    const { jobPage, isMobile } = this.state;
    const { location } = this.props;

    const queryParams = queryString.parse(location.search);

    let payload = {
      isEmbed: false,
      type: "audio",
      jobPage,
      queryParams,
      jobClipPermalink: playingJobClip.permalink,
      isPublic: true,
      isJobPage: true,
      isMobile,
    };

    return payload;
  };

  handlePlayerPlay = (jobClip) => {
    const { jobClips } = this.state;

    // Stop other players
    jobClips.forEach((jc) => {
      if (jc.permalink !== jobClip.permalink) {
        this.playerRefs[jc.permalink].current &&
          this.playerRefs[jc.permalink].current.handlePlayerPause();
        this.mobilePlayerRefs[jc.permalink].current &&
          this.mobilePlayerRefs[jc.permalink].current.handlePlayerPause();
      }
    });
  };

  handleMadeWithPuckClick = (location) => (e) => {
    const { jobPage } = this.state;
    const { location } = this.props;

    const queryParams = queryString.parse(location.search);

    e.preventDefault();

    analytics.track(
      `JobPage Public Clicked Made With Puck`,
      {
        jobPage,
        queryParams,
        location,
      },
      {},
      () => {
        window.location.href = "https://www.careerpuck.com";
      }
    );
  };

  safeContent = (jobPage) => {
    // Get a copy of default whiteList
    const whiteList = xss.getDefaultWhiteList();

    // Allow class attribute on spans
    whiteList.span.push("class");
    whiteList.figure.push("contenteditable", "class");
    whiteList.iframe = ["width", "height", "src", "style"];

    return (
      jobPage?.content &&
      xss.filterXSS(decodeHTML(jobPage.content), { whiteList })
    );
  };

  handleEmailChange = (e) => {
    this.setState({
      email: e.target.value,
    });
  };

  validateScreeningQuestionResponses = () => {
    // Check each question and see if the response is valid
    const { jobPage, screeningQuestionResponses } = this.state;

    const screeningSet = jobPage.screeningSet;
    const screeningQuestionErrors = [];

    screeningSet.questions.forEach((question, i) => {
      const response = screeningQuestionResponses.find(
        (r) => r.permalink === question.id
      );

      if (question.data.isRequired) {
        if (question.type === "text-single") {
          if (!response || !response.value) {
            screeningQuestionErrors.push({
              permalink: question.id,
              message: "Please provide a response",
            });
          }
        } else if (question.type === "phone") {
          if (!response || !response.value) {
            screeningQuestionErrors.push({
              permalink: question.id,
              message: "Please provide a valid phone number",
            });
          }
        } else if (question.type === "email") {
          const isEmailValid = response && isEmail(response.value.trim());
          if (!isEmailValid) {
            screeningQuestionErrors.push({
              permalink: question.id,
              message: "Please provide a valid email",
            });
          }
        } else if (question.type === "boolean") {
          if (!response || response.value === null) {
            screeningQuestionErrors.push({
              permalink: question.id,
              message: "Please make a selection",
            });
          }
        } else if (question.type === "multi-select") {
          if (
            !response ||
            response.value === null ||
            response.value.length === 0
          ) {
            screeningQuestionErrors.push({
              permalink: question.id,
              message: "Please select at least one option",
            });
          }
        }
      }
    });

    console.log(screeningQuestionErrors);

    this.setState({
      screeningQuestionErrors: screeningQuestionErrors,
    });

    return screeningQuestionErrors;
  };

  handleShortFormInputFocus = (e) => {
    const { jobPage } = this.state;
    const { location } = this.props;

    const queryParams = queryString.parse(location.search);

    analytics.track("JobPage Public Focused Short Form", {
      jobPage,
      queryParams,
    });
  };

  handleShortFormApplyClick = async () => {
    const {
      email,
      jobPage,
      screeningQuestionResponses,
      isSubmittingShortForm,
    } = this.state;
    const { dispatch, location, params } = this.props;
    const { jobBoardPermalink, jobPagePermalink } = params;
    const queryParams = queryString.parse(location.search);

    if (isSubmittingShortForm) {
      return;
    }

    this.setState({
      isSubmittingShortForm: true,
    });

    const countryCode = await ipLookup();

    const payload = {
      jobPagePermalink: jobPagePermalink,
      email: email.trim(),
      anonymousIds: getAllAnonymousIds(),
      countryCode,
    };

    if (jobPage.screeningSet) {
      const errors = this.validateScreeningQuestionResponses();
      if (errors.length > 0) {
        this.setState({
          isSubmittingShortForm: false,
        });
        return;
      }

      payload.responses = screeningQuestionResponses;
    }

    const resultAction = await dispatch(
      createShortApplication({
        jobBoardPermalink: jobBoardPermalink,
        payload,
      })
    );
    if (createShortApplication.fulfilled.match(resultAction)) {
      analytics.track("JobPage Public Submitted Short Form", {
        jobPage,
        queryParams,
        email,
        countryCode,
      });

      const queryString = location.search;
      if (jobPage.applyUrl) {
        const params = new URLSearchParams(queryString);
        const url = new URL(jobPage.applyUrl);

        if (
          jobPage.atsSourcePlatform === "icims-api" ||
          jobPage.atsSourcePlatform === "icims-xml"
        ) {
          url.searchParams.append("mode", "prepopulate");
          url.searchParams.append("apply", "yes");
          url.searchParams.append("iiem", email.trim());

          // Append existing query params
          for (const [key, value] of params) {
            url.searchParams.append(key, value);
          }
          window.location.href = url.toString();
        } else {
          // Append existing query params
          for (const [key, value] of params) {
            url.searchParams.append(key, value);
          }
          window.location.href = url.toString();
        }
      } else {
        this.props.navigate(
          `/job-board/${jobBoardPermalink}/job/${jobPagePermalink}/apply${queryString}`
        );
      }
    }

    this.setState({
      isSubmittingShortForm: false,
    });
  };

  handleFocus = () => {
    document.body.scrollIntoView();
  };

  handleScreeningQuestionInputChange = (i) => (e) => {
    const { jobPage, screeningQuestionResponses, screeningQuestionErrors } =
      this.state;

    const screeningSet = jobPage.screeningSet;
    const screeningQuestion = screeningSet.questions[i];

    // Either update the response or add a new one
    const newScreeningQuestionResponses = [...screeningQuestionResponses];
    const existingResponseIndex = newScreeningQuestionResponses.findIndex(
      (r) => r.permalink === screeningQuestion.id
    );

    if (existingResponseIndex > -1) {
      newScreeningQuestionResponses[existingResponseIndex].value =
        e.target.value;
    } else {
      newScreeningQuestionResponses.push({
        permalink: screeningQuestion.id,
        value: e.target.value,
      });
    }

    console.log(newScreeningQuestionResponses);

    this.setState(
      {
        screeningQuestionResponses: newScreeningQuestionResponses,
      },
      () => {
        // We know we've attempted to submit the short app
        if (screeningQuestionErrors) {
          this.validateScreeningQuestionResponses();
        }
      }
    );
  };

  handleScreeningQuestionBooleanChange = (i) => (option) => {
    const { jobPage, screeningQuestionResponses, screeningQuestionErrors } =
      this.state;

    const screeningSet = jobPage.screeningSet;
    const screeningQuestion = screeningSet.questions[i];

    // Either update the response or add a new one
    const newScreeningQuestionResponses = [...screeningQuestionResponses];
    const existingResponseIndex = newScreeningQuestionResponses.findIndex(
      (r) => r.permalink === screeningQuestion.id
    );

    if (existingResponseIndex > -1) {
      newScreeningQuestionResponses[existingResponseIndex].value =
        option.value === "yes" ? true : false;
    } else {
      newScreeningQuestionResponses.push({
        permalink: screeningQuestion.id,
        value: option.value === "yes" ? true : false,
      });
    }

    console.log(newScreeningQuestionResponses);

    this.setState(
      {
        screeningQuestionResponses: newScreeningQuestionResponses,
      },
      () => {
        // We know we've attempted to submit the short app
        if (screeningQuestionErrors) {
          this.validateScreeningQuestionResponses();
        }
      }
    );
  };

  handleScreeningQuestionMultiSelectChange = (i, name) => (e) => {
    const { jobPage, screeningQuestionResponses, screeningQuestionErrors } =
      this.state;

    const screeningSet = jobPage.screeningSet;
    const screeningQuestion = screeningSet.questions[i];

    // Either update the response or add a new one
    const newScreeningQuestionResponses = [...screeningQuestionResponses];
    const existingResponseIndex = newScreeningQuestionResponses.findIndex(
      (r) => r.permalink === screeningQuestion.id
    );

    if (existingResponseIndex > -1) {
      if (e.target.checked) {
        newScreeningQuestionResponses[existingResponseIndex].value.push(name);
      } else {
        newScreeningQuestionResponses[existingResponseIndex].value =
          newScreeningQuestionResponses[existingResponseIndex].value.filter(
            (n) => n !== name
          );
      }
    } else {
      // We know we're adding a check
      newScreeningQuestionResponses.push({
        permalink: screeningQuestion.id,
        value: [name],
      });
    }

    console.log(newScreeningQuestionResponses);

    this.setState(
      {
        screeningQuestionResponses: newScreeningQuestionResponses,
      },
      () => {
        // We know we've attempted to submit the short app
        if (screeningQuestionErrors) {
          this.validateScreeningQuestionResponses();
        }
      }
    );
  };

  handleTeamQuoteExpandClick = (jobClipHighlightPermalink) => () => {
    const { jobPage } = this.state;

    analytics.track("JobPage Team Quote Clicked", {
      jobPage,
      jobClipHighlightPermalink,
    });
  };

  render() {
    const {
      isMini,
      // isMobile,
      // isPlaying,
      isPermalinkValid,
      jobPage,
      jobClipHighlight,
      jobClips,
      // playingJobClip,
      // playingJobClipTrack,
      // shouldResetPlayingJobClipTrack,
      email,
      isEmailTouched,
      // isScrolled,
      screeningQuestionResponses,
      screeningQuestionErrors,
      isSubmittingShortForm,
    } = this.state;
    const { location, params, t } = this.props;
    const { jobBoardPermalink } = params;

    if (!isPermalinkValid) {
      window.location.reload(false);
    }

    let brandingData = {};
    if (jobPage) {
      brandingData = jobPage.employerProfile.brandingData;
    }

    let careerPageUrl = null;
    if (jobPage) {
      careerPageUrl = jobPage.employerProfile.careerPageUrl;
      if (!careerPageUrl && jobPage.atsSourcePlatform === "lever") {
        careerPageUrl = `https://${window.location.hostname}/job-board/${jobBoardPermalink}`;
      }
    }

    const safeContent = this.safeContent(jobPage);

    const isEmailValid = isEmail(email.trim());

    const roleFontUrl = brandingData.roleFontUrl;
    const employerNameFontUrl = brandingData.employerNameFontUrl;
    const jobDescriptionRegularFontUrl =
      brandingData.jobDescriptionRegularFontUrl;
    const jobDescriptionItalicFontUrl =
      brandingData.jobDescriptionItalicFontUrl;
    const jobDescriptionBoldFontUrl = brandingData.jobDescriptionBoldFontUrl;
    const jobDescriptionBoldItalicFontUrl =
      brandingData.jobDescriptionBoldItalicFontUrl;

    const hasJobClips = jobClips?.length > 0;

    let jobPageLocation = "";
    if (jobPage) {
      jobPageLocation = jobPage.location;

      // For Lever: Workplace type of this posting. Defaults to 'unspecified'. Can be one of the following values: onsite, remote, hybrid
      const workplaceType = jobPage.workplaceType;
      if (workplaceType) {
        if (workplaceType === "remote") {
          jobPageLocation += " | Remote";
        } else if (workplaceType === "onsite") {
          jobPageLocation += " | On-site";
        } else if (workplaceType === "hybrid") {
          jobPageLocation += " | Hybrid";
        }
      }
    }

    return (
      <>
        <Helmet
          bodyAttributes={{ style: `background: ${theme.colors.white};` }}
          style={[
            {
              cssText: `
                ${
                  roleFontUrl &&
                  `.role {
                    font-family: "Role Custom Font";
                  }`
                }
                ${
                  employerNameFontUrl &&
                  `.employer-name {
                    font-family: "Employer Name Custom Font"
                  }`
                }
                ${
                  (jobDescriptionRegularFontUrl ||
                    jobDescriptionItalicFontUrl ||
                    jobDescriptionBoldFontUrl ||
                    jobDescriptionBoldItalicFontUrl) &&
                  `.job-description {
                    font-family: "Job Description Custom Font"
                  }`
                }
            `,
            },
          ]}
        >
          {jobPage && (
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "JobPosting",
                title: jobPage.title,
                description: safeContent,
                hiringOrganization: {
                  "@type": "Organization",
                  name: jobPage.employerProfile.name,
                  sameAs: jobPage.employerProfile.emailDomain,
                },
                jobLocation: {
                  "@type": "Place",
                  address: {
                    "@type": "PostalAddress",
                    addressLocality: jobPage.location,
                  },
                },
                employmentType: "FULL_TIME",
                directApply: true,
                datePosted: new Date(jobPage.postedAt).toISOString(),
              })}
            </script>
          )}
        </Helmet>
        {jobPage && jobClips && (
          <Layout isHeaderHidden={true}>
            <EnvironmentIndicator />
            <Wrapper
              onClick={this.handleClick}
              $maxWidth={1512}
              $marginBottom={"0"}
              $padding={theme.spacing.unit * 2}
              // $paddingMobile={theme.spacing.unit * 1}
              $paddingMini={theme.spacing.unit * 1}
              $color={brandingData.primaryTextColor}
            >
              <HeaderContainer>
                <Header>
                  <LogoContainer>
                    {/* <LogoStickyContainer> */}
                    <CompanyLogo
                      logoUrl={brandingData.logoUrl}
                      employerProfile={jobPage.employerProfile}
                      shouldIgnoreCareerPageUrl={true}
                      alt={`${jobPage.employerProfile.name} logo`}
                    />
                    {/* </LogoStickyContainer> */}
                  </LogoContainer>
                  <PageHeaderContainer data-testing="job-title-header">
                    <h1>
                      <Role className={"role"}>{jobPage.title}</Role>
                    </h1>
                    <Location>{jobPageLocation}</Location>
                    <PillButton
                      isBrandedPrimary
                      brandingData={brandingData}
                      onClick={
                        jobPage.formType === "third-party"
                          ? this.handleThirdPartyApplyClick
                          : this.handleApplyClick
                      }
                      aria-label={`${t("Apply to")} ${jobPage.title}`}
                    >
                      {t("Apply")}
                    </PillButton>
                    {hasJobClips && isMini && (
                      <PillButton
                        isBrandedGhost
                        brandingData={brandingData}
                        icon={iconHeadphone}
                        onClick={this.handleHearClipsFromTheTeamClick}
                      >
                        {t("Hear clips from the team")}
                      </PillButton>
                    )}
                  </PageHeaderContainer>
                </Header>
              </HeaderContainer>
              <ColumnsContainer>
                <MiddleColumn
                  $hidePuckBranding={jobPage.employerProfile.hidePuckBranding}
                >
                  {(jobPage.jobBoard.includeJdOnPage &&
                    jobPage.atsSourcePlatform === "greenhouse") ||
                  jobPage.atsSourcePlatform !== "greenhouse" ? (
                    <About
                      ref={this.jobDescriptionRef}
                      dangerouslySetInnerHTML={{ __html: safeContent }}
                      data-testing="job-description"
                      className={"job-description"}
                      color={brandingData.primaryTextColor}
                    />
                  ) : (
                    <JobPageApplication
                      jobPage={jobPage}
                      analyticsPageName={"JobPage"}
                      location={location}
                    ></JobPageApplication>
                  )}
                  {jobPage.formType === "short-form" && (
                    <Element name={"application"}>
                      <ShortFormContainer>
                        <ShortFormTitle>
                          {t("Start your application")}
                        </ShortFormTitle>
                        {jobPage.screeningSet ? (
                          <>
                            {jobPage.screeningSet.questions.map(
                              (screeningQuestion, i) => {
                                if (screeningQuestion.type === "text-single") {
                                  console.log(
                                    screeningQuestionErrors?.find(
                                      (error) =>
                                        error.permalink === screeningQuestion.id
                                    )?.message
                                  );

                                  return (
                                    <Input
                                      isFullWidth
                                      key={screeningQuestion.id}
                                      label={screeningQuestion.data.label}
                                      placeholder={
                                        screeningQuestion.data.placeholder
                                      }
                                      onChange={this.handleScreeningQuestionInputChange(
                                        i
                                      )}
                                      touched={true}
                                      error={
                                        screeningQuestionErrors?.find(
                                          (error) =>
                                            error.permalink ===
                                            screeningQuestion.id
                                        )?.message
                                      }
                                      onFocus={this.handleShortFormInputFocus}
                                    />
                                  );
                                } else if (screeningQuestion.type === "phone") {
                                  return (
                                    <Input
                                      isFullWidth
                                      key={screeningQuestion.id}
                                      label={screeningQuestion.data.label}
                                      placeholder={
                                        screeningQuestion.data.placeholder
                                      }
                                      onChange={this.handleScreeningQuestionInputChange(
                                        i
                                      )}
                                      touched={true}
                                      error={
                                        screeningQuestionErrors?.find(
                                          (error) =>
                                            error.permalink ===
                                            screeningQuestion.id
                                        )?.message
                                      }
                                      onFocus={this.handleShortFormInputFocus}
                                    />
                                  );
                                } else if (screeningQuestion.type === "email") {
                                  return (
                                    <Input
                                      isFullWidth
                                      key={screeningQuestion.id}
                                      label={screeningQuestion.data.label}
                                      placeholder={
                                        screeningQuestion.data.placeholder
                                      }
                                      onChange={this.handleScreeningQuestionInputChange(
                                        i
                                      )}
                                      touched={true}
                                      error={
                                        screeningQuestionErrors?.find(
                                          (error) =>
                                            error.permalink ===
                                            screeningQuestion.id
                                        )?.message
                                      }
                                      onFocus={this.handleShortFormInputFocus}
                                    />
                                  );
                                } else if (
                                  screeningQuestion.type === "boolean"
                                ) {
                                  return (
                                    <div key={screeningQuestion.id}>
                                      <Label
                                        text={screeningQuestion.data.label}
                                      />
                                      <ScreeningQuestionSelect
                                        options={[
                                          { label: "Yes", value: "yes" },
                                          { label: "No", value: "no" },
                                        ]}
                                        onChange={this.handleScreeningQuestionBooleanChange(
                                          i
                                        )}
                                        touched={true}
                                        error={
                                          screeningQuestionErrors?.find(
                                            (error) =>
                                              error.permalink ===
                                              screeningQuestion.id
                                          )?.message
                                        }
                                      />
                                    </div>
                                  );
                                } else if (
                                  screeningQuestion.type === "multi-select"
                                ) {
                                  const hasError =
                                    screeningQuestionErrors?.find(
                                      (error) =>
                                        error.permalink === screeningQuestion.id
                                    );

                                  return (
                                    <div key={screeningQuestion.id}>
                                      <Label
                                        text={screeningQuestion.data.label}
                                      />
                                      {screeningQuestion.data.options.map(
                                        (option) => {
                                          let isChecked = false;
                                          const response =
                                            screeningQuestionResponses.find(
                                              (r) =>
                                                r.permalink ===
                                                screeningQuestion.id
                                            );
                                          if (
                                            response &&
                                            response.value.includes(option.name)
                                          ) {
                                            isChecked = true;
                                          }

                                          return (
                                            <ScreeningQuestionCheckboxContainer>
                                              <Checkbox
                                                label={option.value}
                                                name={option.name}
                                                isChecked={isChecked}
                                                onChange={this.handleScreeningQuestionMultiSelectChange(
                                                  i,
                                                  option.name
                                                )}
                                              />
                                            </ScreeningQuestionCheckboxContainer>
                                          );
                                        }
                                      )}
                                      {hasError && (
                                        <ScreeningQuestionMultiSelectError>
                                          {
                                            screeningQuestionErrors?.find(
                                              (error) =>
                                                error.permalink ===
                                                screeningQuestion.id
                                            ).message
                                          }
                                        </ScreeningQuestionMultiSelectError>
                                      )}
                                    </div>
                                  );
                                }
                                return null;
                              }
                            )}
                            <BottomApplyButton
                              isBrandedPrimary={!isSubmittingShortForm}
                              isLoading={isSubmittingShortForm}
                              brandingData={brandingData}
                              onClick={this.handleShortFormApplyClick}
                            >{`${t("Start application")} →`}</BottomApplyButton>
                          </>
                        ) : (
                          <>
                            <ShortFormEmailInput
                              isFullWidth
                              shouldHideLabel
                              placeholder={"Email address"}
                              onChange={this.handleEmailChange}
                              touched={isEmailTouched}
                              error={
                                !isEmailValid
                                  ? t("Please enter a valid email")
                                  : null
                              }
                              onFocus={this.handleShortFormInputFocus}
                            />
                            <BottomApplyButton
                              isBrandedPrimary={!isSubmittingShortForm}
                              isLoading={isSubmittingShortForm}
                              brandingData={brandingData}
                              onClick={
                                isEmailValid
                                  ? this.handleShortFormApplyClick
                                  : () =>
                                      this.setState({ isEmailTouched: true })
                              }
                            >{`${t("Start application")} →`}</BottomApplyButton>
                          </>
                        )}
                      </ShortFormContainer>
                    </Element>
                  )}
                  {(jobPage.formType === "iframe" ||
                    jobPage.formType === "greenhouse-iframe-v2") && (
                    <Element name={"application"}>
                      <JobPageApplication
                        jobPage={jobPage}
                        analyticsPageName={"JobPage"}
                        location={location}
                      ></JobPageApplication>
                    </Element>
                  )}
                  {jobPage.formType === "third-party" && (
                    <ThirdPartyApplyContainer>
                      <BottomApplyButton
                        isBrandedPrimary
                        brandingData={brandingData}
                        onClick={this.handleThirdPartyApplyClick}
                      >{`${t("Start application")} →`}</BottomApplyButton>
                    </ThirdPartyApplyContainer>
                  )}
                  <SmallBottomContentContainer id="small-bottom-content">
                    {isMini && (
                      <>
                        {!jobPage.employerProfile.hidePuckBranding && (
                          <MobileBadgeContainer>
                            <a
                              href={"https://www.careerpuck.com"}
                              onClick={this.handleMadeWithPuckClick(
                                "mobile-podcasts-top"
                              )}
                            >
                              <Badge
                                src={imageBadge}
                                alt="Made with Puck"
                                color={brandingData.primaryTextColor}
                              />
                            </a>
                          </MobileBadgeContainer>
                        )}
                        {jobClips.map((jobClip, i) => (
                          <div key={i}>
                            <PlayerInternal
                              forwardRef={
                                this.mobilePlayerRefs[jobClip.permalink]
                              }
                              // jobPage={jobPage}
                              jobClip={jobClip}
                              onPlay={() => this.handlePlayerPlay(jobClip)}
                              // playingJobClip={playingJobClip}
                              // onPlay={() => this.handlePlayerPlay(jobClip)}
                              // onPause={() => this.handlePlayerPause(jobClip)}
                              // onJobClipTrackClick={this.handleJobClipTrackClick}
                              // isPlaying={isPlaying}
                              analyticsPayload={this.jobClipAnalyticsPayload(
                                jobClip
                              )}
                              analyticsSrc={"JobPage"}
                              hidePuckBranding={true}
                            />
                          </div>
                        ))}
                        {jobClipHighlight && (
                          <MobileTeamQuoteContainer>
                            <TeamQuote
                              jobClipHighlight={jobClipHighlight}
                              brandingData={brandingData}
                              onExpandClick={this.handleTeamQuoteExpandClick(
                                jobClipHighlight.permalink
                              )}
                            />
                          </MobileTeamQuoteContainer>
                        )}
                      </>
                    )}
                    {jobPage.contentPageLinks.length > 0 && (
                      <ContentPageLinks
                        header={"Resources"}
                        contentPageLinks={jobPage.contentPageLinks}
                        brandingData={brandingData}
                      />
                    )}
                    {careerPageUrl && (
                      <ColumnLink
                        brandingData={brandingData}
                        url={careerPageUrl}
                        title={`${t("See more jobs at")} ${
                          jobPage.employerProfile.name
                        }`}
                      />
                    )}
                  </SmallBottomContentContainer>
                  <MadeWithPuckContainer>
                    <MadeWithPuckBadge
                      onClick={this.handleMadeWithPuckClick("footer")}
                      color={brandingData.primaryTextColor}
                      hoverBackgroundColor={brandingData.secondaryColor}
                    />
                  </MadeWithPuckContainer>
                  <FooterLinksContainer>
                    <FooterLink href="https://www.careerpuck.com/privacy-policy">
                      {t("Read our Privacy Policy")}
                    </FooterLink>
                    <FooterLink href="https://www.careerpuck.com/accessibility-statement">
                      {t("Accessibility Statement")}
                    </FooterLink>
                  </FooterLinksContainer>
                </MiddleColumn>
                {!isMini && (jobClipHighlight || hasJobClips) && (
                  <RightColumn ref={this.rightColumn}>
                    <RightColumnContentContainer
                      ref={this.rightColumnContentContainer}
                      $hidePuckBranding={
                        jobPage.employerProfile.hidePuckBranding
                      }
                    >
                      <RightColumnSpacer ref={this.rightColumnSpacer} />
                      <RightColumnContent ref={this.rightColumnContent}>
                        {!jobPage.employerProfile.hidePuckBranding && (
                          <BadgeContainer>
                            <a
                              href={"https://www.careerpuck.com"}
                              onClick={this.handleMadeWithPuckClick(
                                "podcasts-top"
                              )}
                            >
                              <Badge
                                src={imageBadge}
                                alt="Made with Puck"
                                color={brandingData.primaryTextColor}
                              />
                            </a>
                          </BadgeContainer>
                        )}
                        {jobClips.map((jobClip, i) => (
                          <div key={i}>
                            <PlayerInternal
                              forwardRef={this.playerRefs[jobClip.permalink]}
                              // jobPage={jobPage}
                              jobClip={jobClip}
                              onPlay={() => this.handlePlayerPlay(jobClip)}
                              // playingJobClip={playingJobClip}
                              // onPlay={() => this.handlePlayerPlay(jobClip)}
                              // onPause={() => this.handlePlayerPause(jobClip)}
                              // onJobClipTrackClick={this.handleJobClipTrackClick}
                              // isPlaying={isPlaying}
                              isExpandable={jobClips.length > 1}
                              analyticsPayload={this.jobClipAnalyticsPayload(
                                jobClip
                              )}
                              analyticsSrc={"JobPage"}
                              hidePuckBranding={true}
                              onFocus={i === 0 ? this.handleFocus : null}
                            />
                          </div>
                        ))}
                        {jobClipHighlight && (
                          <TeamQuote
                            jobClipHighlight={jobClipHighlight}
                            brandingData={brandingData}
                            onExpandClick={this.handleTeamQuoteExpandClick(
                              jobClipHighlight.permalink
                            )}
                          />
                        )}
                        {jobPage.contentPageLinks.length > 0 && (
                          <ContentPageLinks
                            header={"Resources"}
                            contentPageLinks={jobPage.contentPageLinks}
                            brandingData={brandingData}
                          />
                        )}
                        {careerPageUrl && (
                          <ColumnLink
                            brandingData={brandingData}
                            url={careerPageUrl}
                            title={`${t("See more jobs at")} ${
                              jobPage.employerProfile.name
                            }`}
                          />
                        )}
                      </RightColumnContent>
                    </RightColumnContentContainer>
                  </RightColumn>
                )}
              </ColumnsContainer>
            </Wrapper>
          </Layout>
        )}
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(
      {
        loadPublicJobPage,
        createShortApplication,
        createApplication,
      },
      dispatch
    ),
  };
}

const enhance = compose(
  withRouter,
  withTranslation(),
  connect(null, mapDispatchToProps)
);

export default enhance(JobPagePublic);
